import React, { useEffect } from 'react'

export function DynamicContent({ content, onClick, onLoad = () => { } }) {
  useEffect(() => {
    if (content) {
      onLoad()
    }
  }, [content])

  return (
    <div onClick={onClick} dangerouslySetInnerHTML={{ __html: content }} />
  )
}
